import {SumaDocumentVerificationResponse} from './suma-document-verification.interface';

export enum AsyncRequestStatusName {
    Requested = 'requested',
    InProgress = 'in_progress',
    Success = 'done_success',
    Failed = 'done_failed'
}

export type AsyncRequestStatus = {
    readonly name: AsyncRequestStatusName;
    readonly date: Date;
}

export type Coordinates = {
    readonly latitude: number;
    readonly longitude: number;
    readonly accuracy: number;
    readonly address: string;
}

export type UploadSelfieVerificationData = {
    base64: string;
}

// TODO: add typings from idanalyzer
export type IdAnalyzerFaceVerificationData = {
    error: any;
    response: any;
};

export enum SumaDocumentVerificationStatus {
    WaitingChecking = 'WaitingChecking',
    ManualIdentification = 'ManualIdentification',
    ManualChecking = 'ManualChecking',
    WaitingData = 'WaitingData',
    Checked = 'Checked'
}

export type SumaDocumentVerificationData = {
    verificationId?: string;
    status?: SumaDocumentVerificationStatus;
    message?: string;
    response: SumaDocumentVerificationResponse;
    error: any;
}

export type SumaIPVerificationData = {
    success?: boolean;
    data?: {
        ip: string;
        tor: boolean;
        vpn: boolean;
        web_proxy: boolean;
        public_proxy: boolean;
    }
}

export type SumaEmailVerificationData = {
    success?: boolean;
    data?: {
        email: string;
        deliverable: boolean;
    }
}
export type SumaPhoneVerificationData = {
    success?: boolean;
    data?: {
        number: string;
        valid: boolean;
        type: string;
        country: string;
        carrier: string
    }
}
export type SumaDocumentVerificationSDKData = {
    url?: string;
    verificationId?: string;
}

export enum AsyncRequestTypeName {
    Geolocation = 'geolocation',
    UploadSelfieVerification = 'upload-selfie-verification',
    IdAnalyzerFaceVerification = 'id-analyzer-face-verification',
    SumaDocumentVerification = 'suma-document-verification',
    SumaDocumentVerificationSDK = 'suma-document-verification-sdk',
    SumaIPVerification = 'suma-ip-verification',
    SumaEmailVerification = 'suma-email-verification',
    SumaPhoneVerification = 'suma-phone-verification',
}

export type AsyncRequestData =
    Coordinates &
    UploadSelfieVerificationData &
    IdAnalyzerFaceVerificationData &
    SumaIPVerificationData &
    SumaEmailVerificationData &
    SumaPhoneVerificationData &
    SumaDocumentVerificationSDKData;

export type ParticipantAsyncRequest<T = AsyncRequestData> = {
    type: AsyncRequestTypeName;
    required?: boolean;
    mayResetAfterSeconds?: number;
    status?: AsyncRequestStatus;
    statusHistory: AsyncRequestStatus[];
    data?: T;
    screenshot?: {
        date: Date;
    }
}